export default __webpack_public_path__ + "static/media/ni.0aa11439.svg";